import request from '@/config/request'
import { UserStatus, UserYigou, UserPhone, bindPhone, oldPhone, newPhone } from './interface'

export const getUserStatus = (data: UserStatus) =>
  request({
    url: '/wxgzh/getUserStatusByCode',
    method: 'post',
    data
  })
  
  export const setUserYigouAccount = (data: UserYigou) =>
  request({
    url: '/wxgzh/weixinGongzhLogin',
    method: 'post',
    data
  })

  export const cheryPhone = (data: UserPhone) =>
  request({
    url: '/wxgzh/sendSms',
    method: 'post',
    data
  })

  export const uerBindPhone = (data: bindPhone) =>
  request({
    url: '/wxgzh/bindPhone',
    method: 'post',
    data
  })

  export const cheryOldPhone = (data: oldPhone) =>
  request({
    url: '/wxgzh/regexUserName',
    method: 'post',
    data
  })

  export const udpateNewPhone = (data: newPhone) =>
  request({
    url: '/wxgzh/updateMobile',
    method: 'post',
    data
  })
  